// salesCampaingManagment


export interface SalesAction
 {
  id                   : number  ,
  name                 : string  ,
  active               : boolean ,
  creationDate         : Date    ,
  mediaId              : number  ,
  productId            : number  ,
  productVariant       : number  ,
  productImage         : number  ,
  timecode             : string  ,
  duration             : string  ,
  adPosition           : string  ,
  adWidth              : number  ,
  onlyQRcode           : boolean ,
  comment1             : string  ,
  comment2             : string  ,
  shapeColor1          : string  ,
  shapeColor2          : string  ,
  backgroundColor1     : string  ,
  backgroundColor2     : string  ,
  withImage            : boolean ,
  alternateImageId     : number  ,
  alternateImageUrl    : string  | null ,
  alternateImageFile   : File    | null ,
  redirectionId        : number  ,
  redirectionUuid      : string  ,
  redirectionTargetUrl : string  ,
  redirectionImageId   : number  ,
  redirectionImageUrl  : string  | null ,
  redirectionImageFile : File    | null ,
  resultImageFile      : File    | null
 }

 export interface SalesCampaign
 {
  id                  : number      ,
  name                : string      ,
  comment             : string      ,
  active              : boolean     ,
  activeScheduled     : boolean ,
  creationDate        : Date        ,
  creationIpAddress   : string      ,
  lastUpdateDate      : Date | null ,
  lastTranscodingDate : Date | null ,
  state               : number      ,
  beginningDate       : Date | null ,
  endingDate          : Date | null ,
  salesActions        : SalesAction []
 }

export const initializedSalesAction = (): SalesAction => (
 {
  id                   : 0                                   ,
  name                 : ''                                  ,
  active               : true                                ,
  creationDate         : new Date ()                         ,
  mediaId              : 0                                   ,
  productId            : 0                                   ,
  productVariant       : 0                                   ,
  productImage         : 0                                   ,
  timecode             : ''                                  ,
  duration             : ''                                  ,
  adPosition           : 'right'                             ,
  adWidth              : 250                                 ,
  onlyQRcode           : false                               ,
  comment1             : 'Offre spéciale'                    ,
  comment2             : 'Scannez le QR code pour commander' ,
  shapeColor1          : "#FFF"                              ,
  shapeColor2          : "#000"                              ,
  backgroundColor1     : "#000"                              ,
  backgroundColor2     : "#ebff40"                           ,
  withImage            : true                                ,
  alternateImageId     : 0                                   ,
  alternateImageUrl    : null                                ,
  alternateImageFile   : null                                ,
  redirectionId        : 0                                   ,
  redirectionUuid      : ''                                  ,
  redirectionTargetUrl : ''                                  ,
  redirectionImageId   : 0                                   ,
  redirectionImageUrl  : null                                ,
  redirectionImageFile : null                                ,
  resultImageFile      : null
 });

export const initializedSalesCampaign = (): SalesCampaign => (
 {
  id                  : 0           ,
  name                : ''          ,
  active              : true        ,
  activeScheduled     : false                               ,
  comment             : ''          ,
  creationDate        : new Date () ,
  creationIpAddress   : ''          ,
  lastUpdateDate      : null        ,
  lastTranscodingDate : null        ,
  state               : -1          ,
  beginningDate       : null        ,
  endingDate          : null        ,
  salesActions        : []
});

